/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import useGoogleMap from './useGoogleMap';

export default function Map({ center, zoom, children, events }) {
  const { maps, map, mapRef, loading } = useGoogleMap({ zoom, center, events });

  useEffect(() => {
    map && map.panTo(center);
  }, [center.lat, center.lng]);

  return (
    <div style={{ height: '550px', width: '100%' }}>
      <div ref={mapRef} className="map-ref" style={{ height: '100%' }} />
      {!loading &&
        React.Children.map(children, (child) => {
          return React.cloneElement(child, { map, maps });
        })}
    </div>
  );
}
